import React from 'react';

import styled from 'styled-components';
import { Icon } from 'view/components/common/Icon';

function addLeadingZero(number) {
    return number?.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
};

const Pagenation = (props) => {
    return (
        <PageNation>
            <p>01-{addLeadingZero(props?.totalPage)} of {addLeadingZero(props?.pageNumber + 1)}</p>
            <PageNationItems>
                <PageView>
                    <span>Row per Page:{addLeadingZero(props?.size)}</span>
                    <Icon icon={"/images/arrow-down.png"} width={12} height={10} />
                </PageView>
                <Pages>
                    <PageButton
                        onClick={()=>{
                            props?.onClickMove(false);
                        }}
                    >
                        <Icon icon={"/images/arrow-left.png"} width={16} height={12} />
                    </PageButton>
                    <span style={{width:30}}>{addLeadingZero(props?.pageNumber + 1)}/{addLeadingZero(props?.totalPage)}</span>
                    <PageButton
                     onClick={()=>{
                        props?.onClickMove(true);
                    }}
                    >
                        <Icon icon={"/images/arrow-right.png"} width={16} height={12} />
                    </PageButton>
                </Pages>
            </PageNationItems>
        </PageNation>
    );
};
export { Pagenation };

const Container = styled.div``;
const PageNation = styled.div`
    position: relative;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 12px 20px;
    border-radius: 0 0 15px 15px;
    font-size: 12px;
    background: #f4f7fce4;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const PageNationItems = styled.div`
    display: flex;
    align-items: center;
`;

const PageView = styled.div`
    cursor: pointer;
    span {
        font-size: 12px;
        font-weight: 700;
        margin-right: 1px;
    }
    img {
        transform: scale(0.8);
    }
    display: flex;
    margin-right: 20px;
`;
const Pages = styled.div`
    display: flex;
    align-items: center;
    span {
        font-size: 12px;
        padding-top: 2px;
        display: flex;
        margin: 0 10px;
    }
`;
const PageButton = styled.div`
    padding: 2px 4px;
    cursor: pointer;
    border-radius: 6px;
    border: solid 1px #464f6040;
`;
